import React from 'react';
import PropTypes from 'prop-types';
import HTMLReactParser from 'html-react-parser';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'next-i18next';
import Button from '@atoms/Button/Button';
import Usps from '@molecules/Usps/Usps';
import VacancyMeta from '@molecules/VacancyMeta/VacancyMeta';
import Hero from '@organisms/Hero/Hero';
import { setVacancyRichData } from '@utils';
import styles from './VacancyDetail.module.scss';

const VacancyDetail = ({ vacancy, host }) => {
  const { t } = useTranslation('vacancy');
  const {
    queryId,
    title,
    backgroundImage,
    companyBranch: {
      company: { name: company },
    },
    address,
    employmentType: { name: employmentType },
    educationLevel: { name: educationLevel },
    publishFrom,
    publishTo,
    description,
    salaryMin,
    salaryMax,
    applyUrl,
    usps,
  } = vacancy;
  const referrer = encodeURIComponent(`https://${host}`);
  const vacancyApplyDeBanensiteUrl = `${process.env.DEBANENSITE_FRONTEND_ENDPOINT}/solliciteer/${queryId}?referrer=${referrer}`;

  return (
    <>
      {/* Rich data */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(
            setVacancyRichData(
              title,
              description,
              company,
              address,
              publishFrom,
              publishTo,
              salaryMin,
              salaryMax,
              employmentType,
              educationLevel
            )
          )}
        </script>
      </Helmet>

      {backgroundImage && backgroundImage.contentUrl && (
        <Hero image={backgroundImage.contentUrl} />
      )}

      <div className={styles.container}>
        <div className={styles.main}>
          <h1 className={styles.title}>{title}</h1>

          <VacancyMeta
            city={address.city}
            employmentType={employmentType}
            educationLevel={educationLevel}
            publishFrom={publishFrom}
            publishTo={publishTo}
          />

          <div className={styles.content}>{HTMLReactParser(description)}</div>

          {usps.length > 0 && <Usps usps={usps} company={company} />}
        </div>

        <div className={styles.bottomNav}>
          <a href="/">&laquo; {t('backToOverview')}</a>
        </div>

        <div className={styles.aside}>
          <div className={styles.asideContent}>
            <h2 className={styles.asideTitle}>{t('getToWork')}</h2>
            <Button href={applyUrl || vacancyApplyDeBanensiteUrl} fullWidth>
              {t('apply')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default VacancyDetail;

VacancyDetail.propTypes = {
  host: PropTypes.string.isRequired,
  vacancy: PropTypes.object.isRequired,
};
